(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-dedicated-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (window.__sacredAllegianceDedicatedReady) return;
  window.__sacredAllegianceDedicatedReady = true;

  function initReveals(page) {
    var reveals = page.querySelectorAll('.sa-reveal');
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.14 });
      reveals.forEach(function (item) { observer.observe(item); });
    } else {
      reveals.forEach(function (item) { item.classList.add('is-visible'); });
    }
  }

  function initFilters(page) {
    var tabs = page.querySelectorAll('[data-sa-filter]');
    var cards = page.querySelectorAll('[data-sa-product-card]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var filter = tab.getAttribute('data-sa-filter');
        tabs.forEach(function (item) {
          var active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        cards.forEach(function (card) {
          var group = card.getAttribute('data-sa-group') || 'all';
          card.hidden = filter !== 'all' && group !== filter;
        });
      });
    });
  }

  function setStatus(form, message, isError) {
    var status = form.querySelector('[data-sa-card-status]');
    if (!status) return;
    status.textContent = message || '';
    status.classList.toggle('is-error', Boolean(isError));
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-sa-ajax-cart]');
    if (!form || !window.fetch) return;
    event.preventDefault();
    if (form.dataset.saSubmitting === 'true') return;
    form.dataset.saSubmitting = 'true';
    var button = form.querySelector('button[type="submit"]');
    var original = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding';
    }
    setStatus(form, '', false);
    fetch(form.action, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (data) { throw data; });
      return response.json();
    }).then(function () {
      setStatus(form, 'Added to cart.', false);
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      return fetch('/cart.js', { headers: { Accept: 'application/json' } });
    }).then(function (response) {
      if (!response || !response.ok) return null;
      return response.json();
    }).then(function (cart) {
      if (!cart) return;
      var count = document.querySelector('.cart-count-bubble span, [data-cart-count], [data-header-cart-count]');
      if (count) count.textContent = cart.item_count;
    }).catch(function (error) {
      var message = error && error.description ? error.description : 'Could not add this item here. Open the product page to choose options.';
      setStatus(form, message, true);
    }).finally(function () {
      form.dataset.saSubmitting = 'false';
      window.setTimeout(function () {
        if (button) {
          button.disabled = button.hasAttribute('data-sa-sold-out');
          button.textContent = original;
        }
      }, 1400);
    });
  });

  document.querySelectorAll('[data-sa-page]').forEach(function (page) {
    initReveals(page);
    initFilters(page);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
